import { Box, Typography, styled } from "@mui/material";
import { colors } from "../../theme/colors";

export const PersonsContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "80px",
  borderRadius: "16px",
  marginBottom: "32px",
  backgroundColor: colors.background.default,
  padding: "16px 24px",
  transition: "flex-direction 0.2s ease, gap 0.2s ease, margin-bottom 0.2s ease, padding 0.2s ease, border-radius 0.2s ease",
  [theme.breakpoints.down("sm")]: {
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "16px",
    marginBottom: "16px",
    padding: "12px 16px",
    borderRadius: "8px",
  },
}));

export const PersonInfo = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

export const PersonAvatar = styled(Box)({
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  backgroundColor: colors.background.lightBlue,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "18px",
  fontWeight: 600,
  color: colors.primary.main,
  flexShrink: 0,
});

export const PersonAvatarImage = styled("img")({
  width: "48px",
  height: "48px",
  borderRadius: "50%",
  objectFit: "cover",
  flexShrink: 0,
});

export const PersonDetails = styled(Box)({
  display: "flex",
  flexDirection: "column",
});

export const PersonName = styled(Typography)({
  fontFamily: "Nunito",
  fontSize: "18px",
  fontWeight: 700,
  color: colors.text.primary,
});

export const PersonRole = styled(Typography)({
  fontSize: "12px",
  color: colors.text.secondary,
  fontFamily: "Nunito",
});

export const PersonExtraInfo = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "24px",
  marginLeft: "auto",
});

export const PersonExtraItem = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  "& svg": {
    width: "16px",
    height: "16px",
    color: colors.text.secondary,
  },
});

export const PersonExtraText = styled(Typography)({
  fontSize: "14px",
  color: colors.text.primary,
  fontFamily: "Nunito",
});
